import React from 'react';
import { Nav, Navbar, NavDropdown } from 'react-bootstrap';
import logo from '../../assets/logo.png'; // Asegúrate de importar tu logo
import { useNavigate } from 'react-router-dom';

export const NavBar: React.FC = () => {
    const navigate = useNavigate();

    const handleNavigation = (path: string) => {
        navigate(path);
    };

    return (
        <>
        <Navbar
            collapseOnSelect
            expand="lg"
            bg="dark"
            variant="dark"
            className="navbar"
        >
            <Navbar.Brand href="#" className="d-flex align-items-center">
            <img src={logo} className="d-inline-block align-top logo" alt="Logo" />
            <span className="fw-bold text-white lbtitulos">C.A.F.</span>
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav" style={{ color: 'black' }}>
            <Nav className="ms-5" style={{color:'white'}}>
                <NavDropdown title="Fútbol" disabled>
                <NavDropdown.Item href="#" onClick={() => handleNavigation('/equipo')}>
                    Fútbol profesional
                </NavDropdown.Item>
                <NavDropdown.Item href="#">Fútbol inferiores</NavDropdown.Item>
                <NavDropdown.Item href="#">Fútbol femenino</NavDropdown.Item>
                <NavDropdown.Item href="#">Fútbol senior</NavDropdown.Item>
                <NavDropdown.Item href="#">Futsal</NavDropdown.Item>
                </NavDropdown>
            </Nav>
            <Nav className="ms-5">
                <NavDropdown title="Deportes" disabled>
                <NavDropdown.Item href="#">Hockey femenino</NavDropdown.Item>
                <NavDropdown.Item href="#">Hockey masculino</NavDropdown.Item>
                <NavDropdown.Item href="#">Hockey inferiores</NavDropdown.Item>
                <NavDropdown.Item href="#">Tenis</NavDropdown.Item>
                </NavDropdown>
            </Nav>
            <Nav className="ms-5">
                <NavDropdown title="FamaClub" >
                <NavDropdown.Item href="#" onClick={() => handleNavigation('/historia')}>
                    Historia
                </NavDropdown.Item>
                <NavDropdown.Item href="#" onClick={()=>{handleNavigation('/comision')}}>
                    Comisión directiva
                </NavDropdown.Item>
                <NavDropdown.Item href="#" disabled>
                    Logros
                </NavDropdown.Item>
                <NavDropdown.Item href="#" disabled>Eventos recreativos</NavDropdown.Item>
                </NavDropdown>
            </Nav>
            <Nav.Link href="#" className="ms-5" disabled>
                FamaShop
            </Nav.Link>
            <Nav className="ms-5">
                <NavDropdown title="Socios">
                <NavDropdown.Item href="#" onClick={() => handleNavigation('/login')}>
                    Iniciar sesión
                </NavDropdown.Item>
                <NavDropdown.Item href="#" onClick={() => handleNavigation('/registrar')}>Registrarme</NavDropdown.Item>
                </NavDropdown>
            </Nav>
            </Navbar.Collapse>
        </Navbar>
        </>
    );
};